import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
import { InviteRepository } from 'data/repository/invite-repository';
import { autoinject } from 'aurelia-framework';
import { validateCompare } from "../customRules/compareValidation";


@resource("invite")
@repository(InviteRepository)
@validatedResource()
export class Invite extends Entity {
	repository: any;

	id: number;
	firstName = null;
	lastName = null;
	email = null;
	confirmEmail = null;
	message = null;
	invitedOn: Date;
	invitedByName: string;
	fullName: string;
	

	constructor() {
		super();

		ValidationRules.customRule(
			'matchesProperty',
			validateCompare,
			'${$displayName} must match ${$getDisplayName($config.otherPropertyName)}', otherPropertyName => ({ otherPropertyName })
		);
	
		// Todo: localization
		ValidationRules
			.ensure((i: Invite) => i.firstName).required()
			.ensure((i: Invite) => i.firstName).maxLength(50)
			.ensure((i: Invite) => i.firstName).matches(/^[a-zA-Z0-9_\-\s]*$/)
			.ensure((i: Invite) => i.lastName).required()
			.ensure((i: Invite) => i.lastName).maxLength(50)
			.ensure((i: Invite) => i.lastName).matches(/^[a-zA-Z0-9_\-\s]*$/)
			.ensure((i: Invite) => i.email).required()
				.maxLength(100)
				.email()
				.then()
				.satisfies(async (value, obj) => {
					const repository: InviteRepository = this.getRepository();
					let result: boolean = await repository.checkForDuplicateEmail(value);
					return (result);
			}).withMessage('That email address has already been sent an invite.')

			.ensure((i: Invite) => i.confirmEmail)
				.required()
				.email()
				.satisfiesRule('matchesProperty', 'email')


			.on(Invite);
	}


}